import { __extends } from "tslib";
import { TaskBaseWebGL } from './TaskBaseWebgGL';
var UV_BLOCKS = function (count, limits) {
    if (count === void 0) { count = 1; }
    if (limits === void 0) { limits = false; }
    return Array.from({ length: count }, function (_, i) {
        var res = "vUv[".concat(i, "] = aPos.xy * uTexMatrix[").concat(i, "].zw + uTexMatrix[").concat(i, "].xy;");
        if (limits) {
            // our aPos should be 0 to 1
            // eslint-disable-next-line max-len
            res += "\nvUvLim[".concat(i, "] = vec4(uTexMatrix[").concat(i, "].xy, uTexMatrix[").concat(i, "].zw + uTexMatrix[").concat(i, "].xy);");
        }
        return res;
    }).join('\n');
};
var VERTEX = function (uvCount, limits) {
    if (uvCount === void 0) { uvCount = 1; }
    if (limits === void 0) { limits = false; }
    return "\nprecision highp float;\nuniform vec4 uPosMatrix;\nuniform vec4 uTexMatrix[".concat(uvCount, "];\n\n/* AGAL legacy atribb resolver MUST reolver this as va0 */\nattribute vec4 aPos; // position\n\nvarying vec2 vUv[").concat(uvCount, "];\n").concat(limits ? "varying vec4 vUvLim[".concat(uvCount, "];") : '', "\n\nvoid main() {\n\tvec4 pos = aPos;\n\n\tpos.xy = pos.xy * uPosMatrix.zw + uPosMatrix.xy;\n\tpos.z = pos.z * 2.0 - pos.w;\n\n    gl_Position = pos;\n\t").concat(UV_BLOCKS(uvCount, limits), "\n}\n\n");
};
var MultipleUVTask = /** @class */ (function (_super) {
    __extends(MultipleUVTask, _super);
    /**
     * Generate vertex shader with multiple UV input
     * @param _uvBlocks Count of UVs used in project
     * @param _limits Generate vUvLim that represent bounds of UV
     */
    function MultipleUVTask(_uvBlocks, _limits) {
        if (_uvBlocks === void 0) { _uvBlocks = 1; }
        if (_limits === void 0) { _limits = false; }
        var _this = _super.call(this, false) || this;
        _this._uvBlocks = _uvBlocks;
        _this._limits = _limits;
        _this.uvMatrices = [];
        _this._dataBuffer = new Float32Array(_uvBlocks * 4 + 4);
        _this.posMatrix = _this._dataBuffer.subarray(0, 4);
        // replace buffer, legacy
        // this is VIEW, posMatrix and uvMatrix reference to value from one
        _this._vertexConstantData = _this._dataBuffer.subarray(0, 8);
        // store composit matrix buffer
        _this._uvMatricesBuffer = _this._dataBuffer.subarray(4, 4 + 4 * _uvBlocks);
        for (var i = 0; i < _uvBlocks; i++) {
            _this.uvMatrices[i] = _this._uvMatricesBuffer.subarray(i * 4, (i + 1) * 4);
        }
        return _this;
    }
    MultipleUVTask.prototype.getVertexCode = function () {
        return VERTEX(this._uvBlocks, this._limits);
    };
    MultipleUVTask.prototype.uploadVertexData = function () {
        this.computeVertexData();
        this._program3D.uploadUniform('uPosMatrix', this.posMatrix);
        this._program3D.uploadUniform('uTexMatrix', this._uvMatricesBuffer);
    };
    return MultipleUVTask;
}(TaskBaseWebGL));
export { MultipleUVTask };
